import { SkeletonComponent } from '$shared/components/skeleton/skeleton.component';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-footer-loading',
  imports: [SkeletonComponent],
  templateUrl: './footer-loading.component.html',
  styleUrl: './footer-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterLoadingComponent {}
